/** @format */

export const GET_CONDITION = "GET_CONDITION";

export const CREATE_CONDITION = "CREATE_CONDITION";

export const DELETE_CONDITION = "DELETE_CONDITION";

export const UPDATE_CONDITION = "UPDATE_CONDITION";
